import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SERVER_URL } from "../config/config";
import "./Dashboard.css";

const Dashboard = () => {
  const [dates, setDates] = useState({
    from: new Date(),
    to: new Date(),
  });

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchDashboard = async () => {
    if (!dates.from || !dates.to) return;

    setLoading(true);
    try {
      const res = await fetch(`${SERVER_URL}/report/bilty-daily-summary`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          date_from: dates.from.toISOString(),
          date_to: dates.to.toISOString(),
        }),
      });

      if (!res.ok) throw new Error("Fetch failed");

      const result = await res.json();
      setData(result);
    } catch (err) {
      console.error("Dashboard error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [dates.from, dates.to]);

  const stations = data?.summary?.summary
    ? Object.entries(data.summary.summary)
    : [];

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="header-left">
          <h1>Daily Docket Report</h1>
          <div className="date-range-badge">
            {dates.from.toLocaleDateString("en-GB")} —{" "}
            {dates.to.toLocaleDateString("en-GB")}
          </div>
        </div>

        <div className="date-filter">
          <div className="date-group">
            <label>From</label>
            <DatePicker
              selected={dates.from}
              onChange={(d) => setDates((p) => ({ ...p, from: d }))}
              dateFormat="dd-MM-yyyy"
              maxDate={dates.to}
              className="date-input"
            />
          </div>

          <div className="date-group">
            <label>To</label>
            <DatePicker
              selected={dates.to}
              onChange={(d) => setDates((p) => ({ ...p, to: d }))}
              dateFormat="dd-MM-yyyy"
              minDate={dates.from}
              className="date-input"
              popperPlacement="bottom-end"
            />
          </div>
        </div>
      </header>

      <div className="overview-section">
        <div className="overview-card">
          <div className="overview-label">
            Total Docket (All Branches)
          </div>
          <div className="overview-value">
            {data?.summary?.total_bilty_all_station_from ?? 0}
          </div>
        </div>

        <div className="overview-card highlight">
          <div className="overview-label">
            Total Amount (All Branches)
          </div>
          <div className="overview-value">
            ₹{" "}
            {(data?.summary?.total_amount_all_station_from ?? 0).toLocaleString()}
          </div>
        </div>
      </div>

      <div className="stations-grid">
        {stations.length === 0 ? (
          <div className="empty-row">
            {loading ? "Loading data..." : "No records for selected period"}
          </div>
        ) : (
          stations.map(([station, vals]) => (
            <div key={station} className="station-card">
              <div className="station-card-header">
                <h3>{station}</h3>
              </div>

              <div className="station-stats">
                <div className="station-stat">
                  <span>Total Docket</span>
                  <strong>{vals.total_bilty ?? 0}</strong>
                </div>

                <div className="station-stat highlight">
                  <span>Total Amount</span>
                  <strong>
                    ₹ {(vals.total_amount ?? 0).toLocaleString()}
                  </strong>
                </div>

                <div className="station-stat">
                  <span>On Time</span>
                  <strong>{vals.delivered_on_time ?? 0}</strong>
                </div>

                <div className="station-stat">
                  <span>Delay</span>
                  <strong>{vals.delivered_delay ?? 0}</strong>
                </div>

                <div className="station-stat">
                  <span>In Transit Delay</span>
                  <strong>{vals.in_transit_delay ?? 0}</strong>
                </div>

                <div className="station-stat">
                  <span>POD Received</span>
                  <strong>{vals.pod_received ?? 0}</strong>
                </div>

                <div className="station-stat">
                  <span>POD Pending</span>
                  <strong>{vals.pod_not_received ?? 0}</strong>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {loading && <div className="loading">Loading...</div>}
    </div>
  );
};

export default Dashboard;
